package feature.cart.repository

import feature.product.model.Product
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow

class CartRepository {
    val cartProductLiveData: MutableStateFlow<List<Product>> = MutableStateFlow(arrayListOf())
    val cartProducts: StateFlow<List<Product>>
        get() = cartProductLiveData

    val cartCountLiveData: MutableStateFlow<Int> = MutableStateFlow(0)
    val cartCount: MutableStateFlow<Int>
        get() = cartCountLiveData

    val mrpLiveData: MutableStateFlow<Float> = MutableStateFlow(0F)
    val mrp: StateFlow<Float>
        get() = mrpLiveData

    val discountLiveData: MutableStateFlow<Float> = MutableStateFlow(0F)
    val discount: StateFlow<Float>
        get() = discountLiveData

    val priceLiveData: MutableStateFlow<Float> = MutableStateFlow(0F)
    val price: StateFlow<Float>
        get() = priceLiveData

    val subtotalLiveData: MutableStateFlow<Float> = MutableStateFlow(0F)
    val subtotal: StateFlow<Float>
        get() = subtotalLiveData

    val taxLiveData: MutableStateFlow<Float> = MutableStateFlow(0F)
    val tax: StateFlow<Float>
        get() = taxLiveData

    val instantDiscountLiveData: MutableStateFlow<Float> = MutableStateFlow(0F)
    val instantDiscount: StateFlow<Float>
        get() = instantDiscountLiveData

    val totalAmountLiveData: MutableStateFlow<Float> = MutableStateFlow(0F)
    val totalAmount: StateFlow<Float>
        get() = totalAmountLiveData


}